/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */
// @deprecated Use package `real-product-manager-wp-client` instead
import "./style/feedback.scss";
import $ from "jquery";
import { getStaticOptions } from "./utils";
import { FeedbackPointer } from "./others";
$(document).on("click", "tr.active .row-actions .deactivate a", function (e) {
  const [slug] = $(this).parents("tr.active").data("plugin").split("/");

  if (getStaticOptions().names[slug]) {
    const href = $(this).attr("href");
    new FeedbackPointer(slug, href, $(this));
    e.preventDefault();
    return false;
  }

  return true;
});